module.exports = __webpack_public_path__ + "img/support_equi_mb_4.0be4adc9.jpg";